/**
 * Config — fábrica centralizada de variáveis de ambiente.
 *
 * Todas as env vars prefixadas com VITE_ devem ser lidas AQUI e somente aqui.
 * O resto do código importa de `config`, nunca de `import.meta.env` diretamente.
 */

import { defaultLogger as log } from './logger';

interface Config {
  readonly ga4Id: string;
  readonly gtmId: string;
  readonly metaPixelId: string;
  readonly googleAdsId: string;
  readonly tiktokPixelId: string;
  readonly isDev: boolean;
  readonly baseUrl: string;
  /**
   * Server-Side Tracking
   * true  = envia eventos via /api/collect (Cloudflare Function)
   *         Escapa de ad blockers, dados enriquecidos pelo servidor
   * false = envia eventos via gtag.js client-side (padrão)
   */
  readonly serverSide: boolean;
}

function createConfig(): Config {
  const ga4Id = import.meta.env.VITE_GA4_ID ?? '';
  const gtmId = import.meta.env.VITE_GTM_ID ?? '';
  const metaPixelId = import.meta.env.VITE_META_PIXEL_ID ?? '';
  const googleAdsId = import.meta.env.VITE_GOOGLE_ADS_ID ?? '';
  const tiktokPixelId = import.meta.env.VITE_TIKTOK_PIXEL_ID ?? '';

  if (import.meta.env.DEV) {
    if (!ga4Id || ga4Id === 'G-XXXXXXXXXX') {
      log.warn('[config] VITE_GA4_ID não configurado. GA4 desativado.');
    }
    if (!gtmId || gtmId === 'GTM-XXXXXXX') {
      log.warn('[config] VITE_GTM_ID não configurado. GTM desativado.');
    }
    if (!metaPixelId) {
      log.warn('[config] VITE_META_PIXEL_ID não configurado. Meta Pixel desativado.');
    }
    if (!googleAdsId) {
      log.warn('[config] VITE_GOOGLE_ADS_ID não configurado. Google Ads desativado.');
    }
    if (!tiktokPixelId) {
      log.warn('[config] VITE_TIKTOK_PIXEL_ID não configurado. TikTok Pixel desativado.');
    }
  }

  return Object.freeze({
    ga4Id,
    gtmId,
    metaPixelId,
    googleAdsId,
    tiktokPixelId,
    isDev: import.meta.env.DEV,
    baseUrl: import.meta.env.BASE_URL ?? '/',
    serverSide: import.meta.env.VITE_APP_ENV === 'production',
  });
}

export const config = createConfig();
